import { ApprovalInfo } from '@data/course/approval/approval';
import React from 'react';
import CourseInfoBox from '../CourseInfoBox';
import BasicChecklist from './BasicChecklist';
import CompletedChecklist from './CompletedChecklist';

interface ChecklistInfoBoxProps {
  courseFrozen: boolean;
  courseApproval: ApprovalInfo;
  curriculumApproval: ApprovalInfo;
  validity: {
    courseData: boolean;
    curriculum: boolean;
    accountInfo: boolean;
    workshop: boolean;
  };
  onConfirm: () => Promise<void>;
}

const ChecklistInfoBox: React.FC<ChecklistInfoBoxProps> = ({
  courseFrozen,
  courseApproval,
  curriculumApproval,
  validity,
  onConfirm,
}) => {
  return (
    <CourseInfoBox
      className='col-span-3 lg:col-span-2'
      header='Course Status'
      description={
        courseFrozen
          ? 'Course review is in progress.'
          : 'Course planning is in progress. Please view the checklist of requirements for teaching approval below.'
      }
    >
      <div className='mt-8'>
        {courseFrozen ? (
          <CompletedChecklist
            courseApproval={courseApproval}
            curriculumApproval={curriculumApproval}
          />
        ) : (
          <BasicChecklist
            onConfirm={onConfirm}
            courseDataValid={validity.courseData}
            filesAttached={validity.curriculum}
            accountInfoCompleted={validity.accountInfo}
            attendedWorkshop={validity.workshop}
          />
        )}
      </div>
    </CourseInfoBox>
  );
};

export default ChecklistInfoBox;
